var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticStyle:{"max-width":"15em"},attrs:{"items":_vm.options,"outlined":"","hide-details":"auto","rules":_vm.rules},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})
}
var staticRenderFns = []

export { render, staticRenderFns }